import { render } from "./work-readiness-program.vue?vue&type=template&id=d691f566&scoped=true"
import script from "./work-readiness-program.vue?vue&type=script&lang=js"
export * from "./work-readiness-program.vue?vue&type=script&lang=js"

import "./work-readiness-program.vue?vue&type=style&index=0&id=d691f566&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d691f566"

export default script